export default {
  "gnav.event.title": "イベント",
  "gnav.event.subTitle": "イベント一覧",
  "gnav.event.eventsMain": "LINK-J主催・共催",
  "gnav.event.memberEvent": "特別会員開催",
  "gnav.event.coSponsorship": "LINK-J協賛・協力",
  "gnav.event.eventsAttend": "出展・参加",
  "gnav.event.archive": "過去イベント",
  "gnav.eventReport.title": "イベントレポート一覧",
  "gnav.eventReport.main": "LINK-J主催・共催",
  "gnav.eventReport.memberEvent": "特別会員開催",
  "gnav.eventReport.coSponsorship": "LINK-J協賛・協力",
  "gnav.eventReport.attend": "出展・参加",
  "gnav.programs.title": "プログラム",
  "gnav.programs.consultation": "Out of Box相談室",
  "gnav.programs.program": "アクセラレーションプログラム",
  "gnav.programs.MedtechProgram_LINK": "起業家育成プログラム",
  "gnav.programs.sandbox": "SANDBOX",
  "gnav.programs.unikorn": `What's "UNIKORN"？`,
  "gnav.programs.linkBiobay": `What's "LINK-BioBAY TOKYO"？`,
  "gnav.interview.title": "インタビュー・コラム",
  "gnav.interview.subTitle": "インタビュー・コラム一覧",
  "gnav.interview.special-interviews": "スペシャルインタビュー",
  "gnav.interview.start-up-interviews": "ベンチャーインタビュー", // ベンチャーインタビュー
  "gnav.interview.supporter": "会報誌 (News Letter)",
  "gnav.interview.serial-column": "連載コラム",
  "gnav.interview.supporter-column": "サポーターコラム",
  "gnav.interview.link-j-staff-blog": "事務局だより",
  "gnav.interview.linkJStaffBlog": "",
  "gnav.interview.startUpInterviews": "",
  "gnav.interview.researcherInterviews": "",
  "gnav.news.title": "ニュース・掲示板",
  "gnav.news.subTitle": "ニュース一覧",
  "gnav.news.topics": "トピック",
  "gnav.news.facilities": "施設",
  "gnav.news.sponsorship": "協賛・協力",
  "gnav.news.program": "アクセラレーション",
  "gnav.news.media": "メディア情報",
  "gnav.news.pressRelease": "プレスリリース",
  "gnav.news.newsEvents": "イベント告知",
  "gnav.news.overseas": "海外関連",
  "gnav.interview.column": "日本橋コラム",
  "gnav.bulletinboard.title": "人と情報の交流掲示板一覧",
  "gnav.bulletinboard.pressRelease": "会員プレスリリース",
  "gnav.bulletinboard.news": "ニュース・事業紹介",
  "gnav.bulletinboard.bulletinBoardsRecruit": "募集",
  "gnav.bulletinboard.bulletinBoardsEvent": "イベント",
  "gnav.about.title": "LINK-Jを知る",
  "gnav.about.greetings": "理事長挨拶",
  "gnav.about.why": "Why in Nihonbashi",
  "gnav.about.west": "What’s LINK-J WEST",
  "gnav.about.overseas": "国内外連携",
  "gnav.about.message": "応援メッセージ",
  "gnav.about.supporter": "サポーター紹介",
  "gnav.about.business.company": "事業内容",
  "gnav.about.business.organization": "組織概要",
  "gnav.membership.business.subscription.brochures": "パンフレット",
  "gnav.membership.business.subscription.biocommunity":
    "GTB日本橋エリアについて",
  "gnav.membership.title": "特別会員",
  "gnav.membership.introductionCorporate": "特別会員一覧",
  "gnav.membership.existing": "特別会員について",
  "gnav.membership.subscription": "入会申し込み",
  "gnav.membership.memberMenu": "専用メニューはこちら",
  "gnav.facilities.title": "施設・アクセス",
  "gnav.facilities.about.room": "ラウンジ・会議室",
  "gnav.facilities.about.office": "オフィス・ラボ",
  "gnav.facilities.facilities": "施設ご予約",
  "gnav.facilities.access": "アクセス",
  "gnav.membership.link.text": "専用メニューはこちら",
  "gnav.facilities.link.text": "施設ご予約",
  "gnav.youtube.link.title": "YouTubeチャンネル",
  "gnav.youtube.alt": "動画",
  "gnav.bnr_footer3.alt": "ライフサイエンスビルシリーズ",
  "gnav.bnr_footer4.alt": "三井リンクラボ",
} as const;
